/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * Time Tracking API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Client,
  ClientFteHistory,
  ClientFteHistoryInput,
  ClientHours,
  ClientHoursTrendPoint,
  ClientInput,
  ClientReport,
  ClientRequester,
  ClientRequesterInput,
  ClientUpdate,
  CustomReport,
  DashboardSummary,
  ErrorResponse,
  GetClientHoursParams,
  GetClientHoursTrendParams,
  GetClientReportParams,
  GetCustomReportParams,
  GetDashboardSummaryParams,
  GetMyReportParams,
  GetRecentActivityParams,
  GetTeamReportParams,
  GetTeamUtilizationParams,
  HealthStatus,
  HourBlockInput,
  HourBlockRecord,
  HourBlockSummary,
  Leave,
  LeaveBulkInput,
  LeaveBulkResult,
  LeaveInput,
  ListLeavesParams,
  ListProjectsParams,
  ListTasksParams,
  ListTimeEntriesParams,
  ListUsersParams,
  LoginInput,
  MemberUtilization,
  MessageResponse,
  MyProductAssignment,
  MyReport,
  MyTaskAssignment,
  Product,
  ProductAssignment,
  ProductAssignmentInput,
  ProductInput,
  ProductUpdate,
  Project,
  ProjectInput,
  ProjectTaskAssignment,
  ProjectTaskAssignmentInput,
  ProjectTaskAssignmentRecord,
  ProjectUpdate,
  PublicHoliday,
  PublicHolidayInput,
  ReportFilterOptions,
  SplitHoursInput,
  Task,
  TaskAssignmentInput,
  TaskInput,
  TaskUpdate,
  TeamReportRow,
  TimeEntry,
  TimeEntryInput,
  TimeEntryUpdate,
  User,
  UserAssignmentInput,
  UserInput,
  UserUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Log in
 */
export const login = async (loginInput: LoginInput, options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginInput)
  }
);}





export const getLoginMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: BodyType<LoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<LoginInput>
    export type LoginMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Log in
 */
export const useLogin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<LoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: BodyType<LoginInput>},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }

export const getCompleteTourUrl = () => {




  return `/api/auth/tour-complete`
}

/**
 * @summary Mark the guided tour as seen
 */
export const completeTour = async ( options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getCompleteTourUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteTourMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTour>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTour>>, TError,void, TContext> => {

const mutationKey = ['completeTour'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTour>>, void> = () => {


          return  completeTour(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTourMutationResult = NonNullable<Awaited<ReturnType<typeof completeTour>>>

    export type CompleteTourMutationError = ErrorType<unknown>

    /**
 * @summary Mark the guided tour as seen
 */
export const useCompleteTour = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTour>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeTour>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompleteTourMutationOptions(options));
    }

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Log out
 */
export const logout = async ( options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<unknown>

    /**
 * @summary Log out
 */
export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Get current user
 */
export const getMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users?${stringifiedParams}` : `/api/users`
}

/**
 * @summary List all users
 */
export const listUsers = async (params?: ListUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<User[]> => {

  return customFetch<User[]>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/api/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(params?: ListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


/**
 * @summary List all users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params?: ListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateUserUrl = () => {




  return `/api/users`
}

/**
 * @summary Create a user
 */
export const createUser = async (userInput: UserInput, options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userInput)
  }
);}





export const getCreateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<UserInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<UserInput>}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: BodyType<UserInput>}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = BodyType<UserInput>
    export type CreateUserMutationError = ErrorType<unknown>

    /**
 * @summary Create a user
 */
export const useCreateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<UserInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: BodyType<UserInput>},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options));
    }

export const getGetUserUrl = (userId: number,) => {




  return `/api/users/${userId}`
}

/**
 * @summary Get a user
 */
export const getUser = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getGetUserUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (userId: number,) => {
    return [
    `/api/users/${userId}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<ErrorResponse>>(userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a user
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<ErrorResponse>>(
 userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateUserUrl = (userId: number,) => {




  return `/api/users/${userId}`
}

/**
 * @summary Update a user
 */
export const updateUser = async (userId: number,
    userUpdate: UserUpdate, options?: Parameters<typeof customFetch>[1]): Promise<User> => {

  return customFetch<User>(getUpdateUserUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userUpdate)
  }
);}





export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {userId: number;data: BodyType<UserUpdate>}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<UserUpdate>
    export type UpdateUserMutationError = ErrorType<unknown>

    /**
 * @summary Update a user
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: number;data: BodyType<UserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {userId: number;data: BodyType<UserUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options));
    }

export const getDeleteUserUrl = (userId: number,) => {




  return `/api/users/${userId}`
}

/**
 * @summary Delete a user
 */
export const deleteUser = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteUserUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = ErrorType<unknown>

    /**
 * @summary Delete a user
 */
export const useDeleteUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options));
    }

export const getListClientsUrl = () => {




  return `/api/clients`
}

/**
 * @summary List all clients
 */
export const listClients = async ( options?: Parameters<typeof customFetch>[1]): Promise<Client[]> => {

  return customFetch<Client[]>(getListClientsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClientsQueryKey = () => {
    return [
    `/api/clients`
    ] as const;
    }


export const getListClientsQueryOptions = <TData = Awaited<ReturnType<typeof listClients>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClients>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClients>>> = ({ signal }) => listClients({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClients>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientsQueryResult = NonNullable<Awaited<ReturnType<typeof listClients>>>
export type ListClientsQueryError = ErrorType<unknown>


/**
 * @summary List all clients
 */

export function useListClients<TData = Awaited<ReturnType<typeof listClients>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClients>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateClientUrl = () => {




  return `/api/clients`
}

/**
 * @summary Create a client
 */
export const createClient = async (clientInput: ClientInput, options?: Parameters<typeof customFetch>[1]): Promise<Client> => {

  return customFetch<Client>(getCreateClientUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clientInput)
  }
);}





export const getCreateClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: BodyType<ClientInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: BodyType<ClientInput>}, TContext> => {

const mutationKey = ['createClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClient>>, {data: BodyType<ClientInput>}> = (props) => {
          const {data} = props ?? {};

          return  createClient(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClientMutationResult = NonNullable<Awaited<ReturnType<typeof createClient>>>
    export type CreateClientMutationBody = BodyType<ClientInput>
    export type CreateClientMutationError = ErrorType<unknown>

    /**
 * @summary Create a client
 */
export const useCreateClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: BodyType<ClientInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createClient>>,
        TError,
        {data: BodyType<ClientInput>},
        TContext
      > => {
      return useMutation(getCreateClientMutationOptions(options));
    }

export const getGetClientUrl = (clientId: number,) => {




  return `/api/clients/${clientId}`
}

/**
 * @summary Get a client
 */
export const getClient = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<Client> => {

  return customFetch<Client>(getGetClientUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClientQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}`
    ] as const;
    }


export const getGetClientQueryOptions = <TData = Awaited<ReturnType<typeof getClient>>, TError = ErrorType<ErrorResponse>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClient>>> = ({ signal }) => getClient(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientQueryResult = NonNullable<Awaited<ReturnType<typeof getClient>>>
export type GetClientQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a client
 */

export function useGetClient<TData = Awaited<ReturnType<typeof getClient>>, TError = ErrorType<ErrorResponse>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateClientUrl = (clientId: number,) => {




  return `/api/clients/${clientId}`
}

/**
 * @summary Update a client
 */
export const updateClient = async (clientId: number,
    clientUpdate: ClientUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Client> => {

  return customFetch<Client>(getUpdateClientUrl(clientId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clientUpdate)
  }
);}





export const getUpdateClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext> => {

const mutationKey = ['updateClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClient>>, {clientId: number;data: BodyType<ClientUpdate>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  updateClient(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClientMutationResult = NonNullable<Awaited<ReturnType<typeof updateClient>>>
    export type UpdateClientMutationBody = BodyType<ClientUpdate>
    export type UpdateClientMutationError = ErrorType<unknown>

    /**
 * @summary Update a client
 */
export const useUpdateClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientId: number;data: BodyType<ClientUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateClient>>,
        TError,
        {clientId: number;data: BodyType<ClientUpdate>},
        TContext
      > => {
      return useMutation(getUpdateClientMutationOptions(options));
    }

export const getDeleteClientUrl = (clientId: number,) => {




  return `/api/clients/${clientId}`
}

/**
 * @summary Delete a client
 */
export const deleteClient = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteClientUrl(clientId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientId: number}, TContext> => {

const mutationKey = ['deleteClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClient>>, {clientId: number}> = (props) => {
          const {clientId} = props ?? {};

          return  deleteClient(clientId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClient>>>

    export type DeleteClientMutationError = ErrorType<unknown>

    /**
 * @summary Delete a client
 */
export const useDeleteClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteClient>>,
        TError,
        {clientId: number},
        TContext
      > => {
      return useMutation(getDeleteClientMutationOptions(options));
    }

export const getListClientAssignmentsUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/assignments`
}

/**
 * @summary List users assigned to a client
 */
export const listClientAssignments = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<User[]> => {

  return customFetch<User[]>(getListClientAssignmentsUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClientAssignmentsQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}/assignments`
    ] as const;
    }


export const getListClientAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listClientAssignments>>, TError = ErrorType<unknown>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientAssignmentsQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientAssignments>>> = ({ signal }) => listClientAssignments(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listClientAssignments>>>
export type ListClientAssignmentsQueryError = ErrorType<unknown>


/**
 * @summary List users assigned to a client
 */

export function useListClientAssignments<TData = Awaited<ReturnType<typeof listClientAssignments>>, TError = ErrorType<unknown>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientAssignmentsQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignUserToClientUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/assignments`
}

/**
 * @summary Assign a user to a client
 */
export const assignUserToClient = async (clientId: number,
    userAssignmentInput: UserAssignmentInput, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getAssignUserToClientUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userAssignmentInput)
  }
);}





export const getAssignUserToClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserToClient>>, TError,{clientId: number;data: BodyType<UserAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignUserToClient>>, TError,{clientId: number;data: BodyType<UserAssignmentInput>}, TContext> => {

const mutationKey = ['assignUserToClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignUserToClient>>, {clientId: number;data: BodyType<UserAssignmentInput>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  assignUserToClient(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignUserToClientMutationResult = NonNullable<Awaited<ReturnType<typeof assignUserToClient>>>
    export type AssignUserToClientMutationBody = BodyType<UserAssignmentInput>
    export type AssignUserToClientMutationError = ErrorType<unknown>

    /**
 * @summary Assign a user to a client
 */
export const useAssignUserToClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserToClient>>, TError,{clientId: number;data: BodyType<UserAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignUserToClient>>,
        TError,
        {clientId: number;data: BodyType<UserAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignUserToClientMutationOptions(options));
    }

export const getRemoveUserFromClientUrl = (clientId: number,
    userId: number,) => {




  return `/api/clients/${clientId}/assignments/${userId}`
}

/**
 * @summary Remove a user from a client
 */
export const removeUserFromClient = async (clientId: number,
    userId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getRemoveUserFromClientUrl(clientId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveUserFromClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromClient>>, TError,{clientId: number;userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeUserFromClient>>, TError,{clientId: number;userId: number}, TContext> => {

const mutationKey = ['removeUserFromClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUserFromClient>>, {clientId: number;userId: number}> = (props) => {
          const {clientId,userId} = props ?? {};

          return  removeUserFromClient(clientId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveUserFromClientMutationResult = NonNullable<Awaited<ReturnType<typeof removeUserFromClient>>>

    export type RemoveUserFromClientMutationError = ErrorType<unknown>

    /**
 * @summary Remove a user from a client
 */
export const useRemoveUserFromClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromClient>>, TError,{clientId: number;userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeUserFromClient>>,
        TError,
        {clientId: number;userId: number},
        TContext
      > => {
      return useMutation(getRemoveUserFromClientMutationOptions(options));
    }

export const getListClientRequestersUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/requesters`
}

/**
 * @summary List the client-side people who request work
 */
export const listClientRequesters = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<ClientRequester[]> => {

  return customFetch<ClientRequester[]>(getListClientRequestersUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClientRequestersQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}/requesters`
    ] as const;
    }


export const getListClientRequestersQueryOptions = <TData = Awaited<ReturnType<typeof listClientRequesters>>, TError = ErrorType<unknown>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientRequesters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientRequestersQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientRequesters>>> = ({ signal }) => listClientRequesters(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientRequesters>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientRequestersQueryResult = NonNullable<Awaited<ReturnType<typeof listClientRequesters>>>
export type ListClientRequestersQueryError = ErrorType<unknown>


/**
 * @summary List the client-side people who request work
 */

export function useListClientRequesters<TData = Awaited<ReturnType<typeof listClientRequesters>>, TError = ErrorType<unknown>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientRequesters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientRequestersQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddClientRequesterUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/requesters`
}

/**
 * @summary Record a new requester on the client's side
 */
export const addClientRequester = async (clientId: number,
    clientRequesterInput: ClientRequesterInput, options?: Parameters<typeof customFetch>[1]): Promise<ClientRequester> => {

  return customFetch<ClientRequester>(getAddClientRequesterUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clientRequesterInput)
  }
);}





export const getAddClientRequesterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClientRequester>>, TError,{clientId: number;data: BodyType<ClientRequesterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addClientRequester>>, TError,{clientId: number;data: BodyType<ClientRequesterInput>}, TContext> => {

const mutationKey = ['addClientRequester'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addClientRequester>>, {clientId: number;data: BodyType<ClientRequesterInput>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  addClientRequester(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddClientRequesterMutationResult = NonNullable<Awaited<ReturnType<typeof addClientRequester>>>
    export type AddClientRequesterMutationBody = BodyType<ClientRequesterInput>
    export type AddClientRequesterMutationError = ErrorType<unknown>

    /**
 * @summary Record a new requester on the client's side
 */
export const useAddClientRequester = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClientRequester>>, TError,{clientId: number;data: BodyType<ClientRequesterInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addClientRequester>>,
        TError,
        {clientId: number;data: BodyType<ClientRequesterInput>},
        TContext
      > => {
      return useMutation(getAddClientRequesterMutationOptions(options));
    }

export const getRemoveClientRequesterUrl = (clientId: number,
    requesterId: number,) => {




  return `/api/clients/${clientId}/requesters/${requesterId}`
}

/**
 * @summary Remove a requester from a client
 */
export const removeClientRequester = async (clientId: number,
    requesterId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getRemoveClientRequesterUrl(clientId,requesterId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveClientRequesterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeClientRequester>>, TError,{clientId: number;requesterId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeClientRequester>>, TError,{clientId: number;requesterId: number}, TContext> => {

const mutationKey = ['removeClientRequester'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeClientRequester>>, {clientId: number;requesterId: number}> = (props) => {
          const {clientId,requesterId} = props ?? {};

          return  removeClientRequester(clientId,requesterId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveClientRequesterMutationResult = NonNullable<Awaited<ReturnType<typeof removeClientRequester>>>

    export type RemoveClientRequesterMutationError = ErrorType<unknown>

    /**
 * @summary Remove a requester from a client
 */
export const useRemoveClientRequester = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeClientRequester>>, TError,{clientId: number;requesterId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeClientRequester>>,
        TError,
        {clientId: number;requesterId: number},
        TContext
      > => {
      return useMutation(getRemoveClientRequesterMutationOptions(options));
    }

export const getListClientFteHistoryUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/fte-history`
}

/**
 * @summary List FTE history for a client
 */
export const listClientFteHistory = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<ClientFteHistory[]> => {

  return customFetch<ClientFteHistory[]>(getListClientFteHistoryUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClientFteHistoryQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}/fte-history`
    ] as const;
    }


export const getListClientFteHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listClientFteHistory>>, TError = ErrorType<unknown>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientFteHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientFteHistoryQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientFteHistory>>> = ({ signal }) => listClientFteHistory(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientFteHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientFteHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listClientFteHistory>>>
export type ListClientFteHistoryQueryError = ErrorType<unknown>


/**
 * @summary List FTE history for a client
 */

export function useListClientFteHistory<TData = Awaited<ReturnType<typeof listClientFteHistory>>, TError = ErrorType<unknown>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientFteHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientFteHistoryQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddClientFteHistoryUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/fte-history`
}

/**
 * @summary Add an FTE history entry for a client
 */
export const addClientFteHistory = async (clientId: number,
    clientFteHistoryInput: ClientFteHistoryInput, options?: Parameters<typeof customFetch>[1]): Promise<ClientFteHistory> => {

  return customFetch<ClientFteHistory>(getAddClientFteHistoryUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(clientFteHistoryInput)
  }
);}





export const getAddClientFteHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClientFteHistory>>, TError,{clientId: number;data: BodyType<ClientFteHistoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addClientFteHistory>>, TError,{clientId: number;data: BodyType<ClientFteHistoryInput>}, TContext> => {

const mutationKey = ['addClientFteHistory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addClientFteHistory>>, {clientId: number;data: BodyType<ClientFteHistoryInput>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  addClientFteHistory(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddClientFteHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof addClientFteHistory>>>
    export type AddClientFteHistoryMutationBody = BodyType<ClientFteHistoryInput>
    export type AddClientFteHistoryMutationError = ErrorType<unknown>

    /**
 * @summary Add an FTE history entry for a client
 */
export const useAddClientFteHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClientFteHistory>>, TError,{clientId: number;data: BodyType<ClientFteHistoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addClientFteHistory>>,
        TError,
        {clientId: number;data: BodyType<ClientFteHistoryInput>},
        TContext
      > => {
      return useMutation(getAddClientFteHistoryMutationOptions(options));
    }

export const getDeleteClientFteHistoryUrl = (clientId: number,
    entryId: number,) => {




  return `/api/clients/${clientId}/fte-history/${entryId}`
}

/**
 * @summary Delete an FTE history entry
 */
export const deleteClientFteHistory = async (clientId: number,
    entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteClientFteHistoryUrl(clientId,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteClientFteHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientFteHistory>>, TError,{clientId: number;entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClientFteHistory>>, TError,{clientId: number;entryId: number}, TContext> => {

const mutationKey = ['deleteClientFteHistory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClientFteHistory>>, {clientId: number;entryId: number}> = (props) => {
          const {clientId,entryId} = props ?? {};

          return  deleteClientFteHistory(clientId,entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientFteHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClientFteHistory>>>

    export type DeleteClientFteHistoryMutationError = ErrorType<unknown>

    /**
 * @summary Delete an FTE history entry
 */
export const useDeleteClientFteHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClientFteHistory>>, TError,{clientId: number;entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteClientFteHistory>>,
        TError,
        {clientId: number;entryId: number},
        TContext
      > => {
      return useMutation(getDeleteClientFteHistoryMutationOptions(options));
    }

export const getListProjectsUrl = (params?: ListProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projects?${stringifiedParams}` : `/api/projects`
}

/**
 * @summary List projects
 */
export const listProjects = async (params?: ListProjectsParams, options?: Parameters<typeof customFetch>[1]): Promise<Project[]> => {

  return customFetch<Project[]>(getListProjectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectsQueryKey = (params?: ListProjectsParams,) => {
    return [
    `/api/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<unknown>>(params?: ListProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = ErrorType<unknown>


/**
 * @summary List projects
 */

export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<unknown>>(
 params?: ListProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProjectUrl = () => {




  return `/api/projects`
}

/**
 * @summary Create a project
 */
export const createProject = async (projectInput: ProjectInput, options?: Parameters<typeof customFetch>[1]): Promise<Project> => {

  return customFetch<Project>(getCreateProjectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(projectInput)
  }
);}





export const getCreateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<ProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<ProjectInput>}, TContext> => {

const mutationKey = ['createProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {data: BodyType<ProjectInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = BodyType<ProjectInput>
    export type CreateProjectMutationError = ErrorType<unknown>

    /**
 * @summary Create a project
 */
export const useCreateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{data: BodyType<ProjectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {data: BodyType<ProjectInput>},
        TContext
      > => {
      return useMutation(getCreateProjectMutationOptions(options));
    }

export const getGetProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Get a project
 */
export const getProject = async (projectId: number, options?: Parameters<typeof customFetch>[1]): Promise<Project> => {

  return customFetch<Project>(getGetProjectUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProjectQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}`
    ] as const;
    }


export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<ErrorResponse>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<ErrorResponse>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProjectQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Update a project
 */
export const updateProject = async (projectId: number,
    projectUpdate: ProjectUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Project> => {

  return customFetch<Project>(getUpdateProjectUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(projectUpdate)
  }
);}





export const getUpdateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: number;data: BodyType<ProjectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: number;data: BodyType<ProjectUpdate>}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {projectId: number;data: BodyType<ProjectUpdate>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  updateProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = BodyType<ProjectUpdate>
    export type UpdateProjectMutationError = ErrorType<unknown>

    /**
 * @summary Update a project
 */
export const useUpdateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{projectId: number;data: BodyType<ProjectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {projectId: number;data: BodyType<ProjectUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options));
    }

export const getDeleteProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}`
}

/**
 * @summary Delete a project
 */
export const deleteProject = async (projectId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteProjectUrl(projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: number}, TContext> => {

const mutationKey = ['deleteProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {projectId: number}> = (props) => {
          const {projectId} = props ?? {};

          return  deleteProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = ErrorType<unknown>

    /**
 * @summary Delete a project
 */
export const useDeleteProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{projectId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {projectId: number},
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options));
    }

export const getListProjectAssignmentsUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/assignments`
}

/**
 * @summary List users assigned to a project
 */
export const listProjectAssignments = async (projectId: number, options?: Parameters<typeof customFetch>[1]): Promise<User[]> => {

  return customFetch<User[]>(getListProjectAssignmentsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectAssignmentsQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/assignments`
    ] as const;
    }


export const getListProjectAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectAssignments>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectAssignmentsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectAssignments>>> = ({ signal }) => listProjectAssignments(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectAssignments>>>
export type ListProjectAssignmentsQueryError = ErrorType<unknown>


/**
 * @summary List users assigned to a project
 */

export function useListProjectAssignments<TData = Awaited<ReturnType<typeof listProjectAssignments>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectAssignmentsQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignUserToProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/assignments`
}

/**
 * @summary Assign a user to a project
 */
export const assignUserToProject = async (projectId: number,
    userAssignmentInput: UserAssignmentInput, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getAssignUserToProjectUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userAssignmentInput)
  }
);}





export const getAssignUserToProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserToProject>>, TError,{projectId: number;data: BodyType<UserAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignUserToProject>>, TError,{projectId: number;data: BodyType<UserAssignmentInput>}, TContext> => {

const mutationKey = ['assignUserToProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignUserToProject>>, {projectId: number;data: BodyType<UserAssignmentInput>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  assignUserToProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignUserToProjectMutationResult = NonNullable<Awaited<ReturnType<typeof assignUserToProject>>>
    export type AssignUserToProjectMutationBody = BodyType<UserAssignmentInput>
    export type AssignUserToProjectMutationError = ErrorType<unknown>

    /**
 * @summary Assign a user to a project
 */
export const useAssignUserToProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUserToProject>>, TError,{projectId: number;data: BodyType<UserAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignUserToProject>>,
        TError,
        {projectId: number;data: BodyType<UserAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignUserToProjectMutationOptions(options));
    }

export const getRemoveUserFromProjectUrl = (projectId: number,
    userId: number,) => {




  return `/api/projects/${projectId}/assignments/${userId}`
}

/**
 * @summary Remove a user from a project
 */
export const removeUserFromProject = async (projectId: number,
    userId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getRemoveUserFromProjectUrl(projectId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveUserFromProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromProject>>, TError,{projectId: number;userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeUserFromProject>>, TError,{projectId: number;userId: number}, TContext> => {

const mutationKey = ['removeUserFromProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUserFromProject>>, {projectId: number;userId: number}> = (props) => {
          const {projectId,userId} = props ?? {};

          return  removeUserFromProject(projectId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveUserFromProjectMutationResult = NonNullable<Awaited<ReturnType<typeof removeUserFromProject>>>

    export type RemoveUserFromProjectMutationError = ErrorType<unknown>

    /**
 * @summary Remove a user from a project
 */
export const useRemoveUserFromProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromProject>>, TError,{projectId: number;userId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeUserFromProject>>,
        TError,
        {projectId: number;userId: number},
        TContext
      > => {
      return useMutation(getRemoveUserFromProjectMutationOptions(options));
    }

export const getListProjectTasksUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/tasks`
}

/**
 * @summary List tasks enabled for a project
 */
export const listProjectTasks = async (projectId: number, options?: Parameters<typeof customFetch>[1]): Promise<Task[]> => {

  return customFetch<Task[]>(getListProjectTasksUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectTasksQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/tasks`
    ] as const;
    }


export const getListProjectTasksQueryOptions = <TData = Awaited<ReturnType<typeof listProjectTasks>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectTasksQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectTasks>>> = ({ signal }) => listProjectTasks(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectTasks>>>
export type ListProjectTasksQueryError = ErrorType<unknown>


/**
 * @summary List tasks enabled for a project
 */

export function useListProjectTasks<TData = Awaited<ReturnType<typeof listProjectTasks>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectTasksQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignTaskToProjectUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/tasks`
}

/**
 * @summary Enable a global task for a project
 */
export const assignTaskToProject = async (projectId: number,
    taskAssignmentInput: TaskAssignmentInput, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getAssignTaskToProjectUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskAssignmentInput)
  }
);}





export const getAssignTaskToProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTaskToProject>>, TError,{projectId: number;data: BodyType<TaskAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignTaskToProject>>, TError,{projectId: number;data: BodyType<TaskAssignmentInput>}, TContext> => {

const mutationKey = ['assignTaskToProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignTaskToProject>>, {projectId: number;data: BodyType<TaskAssignmentInput>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  assignTaskToProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignTaskToProjectMutationResult = NonNullable<Awaited<ReturnType<typeof assignTaskToProject>>>
    export type AssignTaskToProjectMutationBody = BodyType<TaskAssignmentInput>
    export type AssignTaskToProjectMutationError = ErrorType<unknown>

    /**
 * @summary Enable a global task for a project
 */
export const useAssignTaskToProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTaskToProject>>, TError,{projectId: number;data: BodyType<TaskAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignTaskToProject>>,
        TError,
        {projectId: number;data: BodyType<TaskAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignTaskToProjectMutationOptions(options));
    }

export const getRemoveTaskFromProjectUrl = (projectId: number,
    taskId: number,) => {




  return `/api/projects/${projectId}/tasks/${taskId}`
}

/**
 * @summary Remove a task from a project
 */
export const removeTaskFromProject = async (projectId: number,
    taskId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getRemoveTaskFromProjectUrl(projectId,taskId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveTaskFromProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTaskFromProject>>, TError,{projectId: number;taskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTaskFromProject>>, TError,{projectId: number;taskId: number}, TContext> => {

const mutationKey = ['removeTaskFromProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTaskFromProject>>, {projectId: number;taskId: number}> = (props) => {
          const {projectId,taskId} = props ?? {};

          return  removeTaskFromProject(projectId,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTaskFromProjectMutationResult = NonNullable<Awaited<ReturnType<typeof removeTaskFromProject>>>

    export type RemoveTaskFromProjectMutationError = ErrorType<unknown>

    /**
 * @summary Remove a task from a project
 */
export const useRemoveTaskFromProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTaskFromProject>>, TError,{projectId: number;taskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTaskFromProject>>,
        TError,
        {projectId: number;taskId: number},
        TContext
      > => {
      return useMutation(getRemoveTaskFromProjectMutationOptions(options));
    }

export const getListTasksUrl = (params?: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks?${stringifiedParams}` : `/api/tasks`
}

/**
 * @summary List tasks
 */
export const listTasks = async (params?: ListTasksParams, options?: Parameters<typeof customFetch>[1]): Promise<Task[]> => {

  return customFetch<Task[]>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/api/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = ErrorType<unknown>


/**
 * @summary List tasks
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = ErrorType<unknown>>(
 params?: ListTasksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskUrl = () => {




  return `/api/tasks`
}

/**
 * @summary Create a task
 */
export const createTask = async (taskInput: TaskInput, options?: Parameters<typeof customFetch>[1]): Promise<Task> => {

  return customFetch<Task>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskInput)
  }
);}





export const getCreateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: BodyType<TaskInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<TaskInput>
    export type CreateTaskMutationError = ErrorType<unknown>

    /**
 * @summary Create a task
 */
export const useCreateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<TaskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: BodyType<TaskInput>},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options));
    }

export const getGetTaskUrl = (taskId: number,) => {




  return `/api/tasks/${taskId}`
}

/**
 * @summary Get a task
 */
export const getTask = async (taskId: number, options?: Parameters<typeof customFetch>[1]): Promise<Task> => {

  return customFetch<Task>(getGetTaskUrl(taskId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskQueryKey = (taskId: number,) => {
    return [
    `/api/tasks/${taskId}`
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = ErrorType<ErrorResponse>>(taskId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a task
 */

export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = ErrorType<ErrorResponse>>(
 taskId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskQueryOptions(taskId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTaskUrl = (taskId: number,) => {




  return `/api/tasks/${taskId}`
}

/**
 * @summary Update a task
 */
export const updateTask = async (taskId: number,
    taskUpdate: TaskUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Task> => {

  return customFetch<Task>(getUpdateTaskUrl(taskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskUpdate)
  }
);}





export const getUpdateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: number;data: BodyType<TaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: number;data: BodyType<TaskUpdate>}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {taskId: number;data: BodyType<TaskUpdate>}> = (props) => {
          const {taskId,data} = props ?? {};

          return  updateTask(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = BodyType<TaskUpdate>
    export type UpdateTaskMutationError = ErrorType<unknown>

    /**
 * @summary Update a task
 */
export const useUpdateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: number;data: BodyType<TaskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {taskId: number;data: BodyType<TaskUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options));
    }

export const getDeleteTaskUrl = (taskId: number,) => {




  return `/api/tasks/${taskId}`
}

/**
 * @summary Delete a task
 */
export const deleteTask = async (taskId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteTaskUrl(taskId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  deleteTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = ErrorType<unknown>

    /**
 * @summary Delete a task
 */
export const useDeleteTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options));
    }

export const getListTimeEntriesUrl = (params?: ListTimeEntriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/time-entries?${stringifiedParams}` : `/api/time-entries`
}

/**
 * @summary List time entries
 */
export const listTimeEntries = async (params?: ListTimeEntriesParams, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry[]> => {

  return customFetch<TimeEntry[]>(getListTimeEntriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTimeEntriesQueryKey = (params?: ListTimeEntriesParams,) => {
    return [
    `/api/time-entries`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTimeEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listTimeEntries>>, TError = ErrorType<unknown>>(params?: ListTimeEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTimeEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTimeEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTimeEntries>>> = ({ signal }) => listTimeEntries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTimeEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTimeEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listTimeEntries>>>
export type ListTimeEntriesQueryError = ErrorType<unknown>


/**
 * @summary List time entries
 */

export function useListTimeEntries<TData = Awaited<ReturnType<typeof listTimeEntries>>, TError = ErrorType<unknown>>(
 params?: ListTimeEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTimeEntries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTimeEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTimeEntryUrl = () => {




  return `/api/time-entries`
}

/**
 * @summary Log time
 */
export const createTimeEntry = async (timeEntryInput: TimeEntryInput, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getCreateTimeEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeEntryInput)
  }
);}





export const getCreateTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimeEntry>>, TError,{data: BodyType<TimeEntryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTimeEntry>>, TError,{data: BodyType<TimeEntryInput>}, TContext> => {

const mutationKey = ['createTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimeEntry>>, {data: BodyType<TimeEntryInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTimeEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createTimeEntry>>>
    export type CreateTimeEntryMutationBody = BodyType<TimeEntryInput>
    export type CreateTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Log time
 */
export const useCreateTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimeEntry>>, TError,{data: BodyType<TimeEntryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTimeEntry>>,
        TError,
        {data: BodyType<TimeEntryInput>},
        TContext
      > => {
      return useMutation(getCreateTimeEntryMutationOptions(options));
    }

export const getGetTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}`
}

/**
 * @summary Get a time entry
 */
export const getTimeEntry = async (entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getGetTimeEntryUrl(entryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTimeEntryQueryKey = (entryId: number,) => {
    return [
    `/api/time-entries/${entryId}`
    ] as const;
    }


export const getGetTimeEntryQueryOptions = <TData = Awaited<ReturnType<typeof getTimeEntry>>, TError = ErrorType<ErrorResponse>>(entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeEntry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeEntryQueryKey(entryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeEntry>>> = ({ signal }) => getTimeEntry(entryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entryId !== null && entryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimeEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeEntry>>>
export type GetTimeEntryQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a time entry
 */

export function useGetTimeEntry<TData = Awaited<ReturnType<typeof getTimeEntry>>, TError = ErrorType<ErrorResponse>>(
 entryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeEntry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTimeEntryQueryOptions(entryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}`
}

/**
 * @summary Update a time entry
 */
export const updateTimeEntry = async (entryId: number,
    timeEntryUpdate: TimeEntryUpdate, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getUpdateTimeEntryUrl(entryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeEntryUpdate)
  }
);}





export const getUpdateTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimeEntry>>, TError,{entryId: number;data: BodyType<TimeEntryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTimeEntry>>, TError,{entryId: number;data: BodyType<TimeEntryUpdate>}, TContext> => {

const mutationKey = ['updateTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTimeEntry>>, {entryId: number;data: BodyType<TimeEntryUpdate>}> = (props) => {
          const {entryId,data} = props ?? {};

          return  updateTimeEntry(entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateTimeEntry>>>
    export type UpdateTimeEntryMutationBody = BodyType<TimeEntryUpdate>
    export type UpdateTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Update a time entry
 */
export const useUpdateTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimeEntry>>, TError,{entryId: number;data: BodyType<TimeEntryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTimeEntry>>,
        TError,
        {entryId: number;data: BodyType<TimeEntryUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTimeEntryMutationOptions(options));
    }

export const getDeleteTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}`
}

/**
 * @summary Delete a time entry
 */
export const deleteTimeEntry = async (entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteTimeEntryUrl(entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimeEntry>>, TError,{entryId: number}, TContext> => {

const mutationKey = ['deleteTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimeEntry>>, {entryId: number}> = (props) => {
          const {entryId} = props ?? {};

          return  deleteTimeEntry(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimeEntry>>>

    export type DeleteTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Delete a time entry
 */
export const useDeleteTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTimeEntry>>,
        TError,
        {entryId: number},
        TContext
      > => {
      return useMutation(getDeleteTimeEntryMutationOptions(options));
    }

export const getSplitTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}/split`
}

/**
 * @summary Split entry hours into billable and non-billable (Associate+)
 */
export const splitTimeEntry = async (entryId: number,
    splitHoursInput: SplitHoursInput, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getSplitTimeEntryUrl(entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(splitHoursInput)
  }
);}





export const getSplitTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitTimeEntry>>, TError,{entryId: number;data: BodyType<SplitHoursInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof splitTimeEntry>>, TError,{entryId: number;data: BodyType<SplitHoursInput>}, TContext> => {

const mutationKey = ['splitTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof splitTimeEntry>>, {entryId: number;data: BodyType<SplitHoursInput>}> = (props) => {
          const {entryId,data} = props ?? {};

          return  splitTimeEntry(entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SplitTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof splitTimeEntry>>>
    export type SplitTimeEntryMutationBody = BodyType<SplitHoursInput>
    export type SplitTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Split entry hours into billable and non-billable (Associate+)
 */
export const useSplitTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitTimeEntry>>, TError,{entryId: number;data: BodyType<SplitHoursInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof splitTimeEntry>>,
        TError,
        {entryId: number;data: BodyType<SplitHoursInput>},
        TContext
      > => {
      return useMutation(getSplitTimeEntryMutationOptions(options));
    }

export const getApproveTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}/approve`
}

/**
 * @summary Approve a time entry
 */
export const approveTimeEntry = async (entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getApproveTimeEntryUrl(entryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{entryId: number}, TContext> => {

const mutationKey = ['approveTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTimeEntry>>, {entryId: number}> = (props) => {
          const {entryId} = props ?? {};

          return  approveTimeEntry(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof approveTimeEntry>>>

    export type ApproveTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Approve a time entry
 */
export const useApproveTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveTimeEntry>>,
        TError,
        {entryId: number},
        TContext
      > => {
      return useMutation(getApproveTimeEntryMutationOptions(options));
    }

export const getRejectTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}/reject`
}

/**
 * @summary Reject a time entry
 */
export const rejectTimeEntry = async (entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getRejectTimeEntryUrl(entryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRejectTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{entryId: number}, TContext> => {

const mutationKey = ['rejectTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectTimeEntry>>, {entryId: number}> = (props) => {
          const {entryId} = props ?? {};

          return  rejectTimeEntry(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof rejectTimeEntry>>>

    export type RejectTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Reject a time entry
 */
export const useRejectTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectTimeEntry>>,
        TError,
        {entryId: number},
        TContext
      > => {
      return useMutation(getRejectTimeEntryMutationOptions(options));
    }

export const getReopenTimeEntryUrl = (entryId: number,) => {




  return `/api/time-entries/${entryId}/reopen`
}

/**
 * @summary Reopen an approved time entry so it can be edited again
 */
export const reopenTimeEntry = async (entryId: number, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry> => {

  return customFetch<TimeEntry>(getReopenTimeEntryUrl(entryId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReopenTimeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenTimeEntry>>, TError,{entryId: number}, TContext> => {

const mutationKey = ['reopenTimeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenTimeEntry>>, {entryId: number}> = (props) => {
          const {entryId} = props ?? {};

          return  reopenTimeEntry(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenTimeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof reopenTimeEntry>>>

    export type ReopenTimeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Reopen an approved time entry so it can be edited again
 */
export const useReopenTimeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenTimeEntry>>, TError,{entryId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reopenTimeEntry>>,
        TError,
        {entryId: number},
        TContext
      > => {
      return useMutation(getReopenTimeEntryMutationOptions(options));
    }

export const getGetDashboardSummaryUrl = (params?: GetDashboardSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/summary?${stringifiedParams}` : `/api/dashboard/summary`
}

/**
 * @summary Overall hours summary
 */
export const getDashboardSummary = async (params?: GetDashboardSummaryParams, options?: Parameters<typeof customFetch>[1]): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = (params?: GetDashboardSummaryParams,) => {
    return [
    `/api/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Overall hours summary
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
 params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientHoursUrl = (params?: GetClientHoursParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/client-hours?${stringifiedParams}` : `/api/dashboard/client-hours`
}

/**
 * @summary Hours breakdown per client
 */
export const getClientHours = async (params?: GetClientHoursParams, options?: Parameters<typeof customFetch>[1]): Promise<ClientHours[]> => {

  return customFetch<ClientHours[]>(getGetClientHoursUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClientHoursQueryKey = (params?: GetClientHoursParams,) => {
    return [
    `/api/dashboard/client-hours`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientHoursQueryOptions = <TData = Awaited<ReturnType<typeof getClientHours>>, TError = ErrorType<unknown>>(params?: GetClientHoursParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHours>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientHoursQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientHours>>> = ({ signal }) => getClientHours(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientHours>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientHoursQueryResult = NonNullable<Awaited<ReturnType<typeof getClientHours>>>
export type GetClientHoursQueryError = ErrorType<unknown>


/**
 * @summary Hours breakdown per client
 */

export function useGetClientHours<TData = Awaited<ReturnType<typeof getClientHours>>, TError = ErrorType<unknown>>(
 params?: GetClientHoursParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHours>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientHoursQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamUtilizationUrl = (params?: GetTeamUtilizationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/utilization?${stringifiedParams}` : `/api/dashboard/utilization`
}

/**
 * @summary Team member utilization
 */
export const getTeamUtilization = async (params?: GetTeamUtilizationParams, options?: Parameters<typeof customFetch>[1]): Promise<MemberUtilization[]> => {

  return customFetch<MemberUtilization[]>(getGetTeamUtilizationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamUtilizationQueryKey = (params?: GetTeamUtilizationParams,) => {
    return [
    `/api/dashboard/utilization`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamUtilizationQueryOptions = <TData = Awaited<ReturnType<typeof getTeamUtilization>>, TError = ErrorType<unknown>>(params?: GetTeamUtilizationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUtilization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamUtilizationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamUtilization>>> = ({ signal }) => getTeamUtilization(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamUtilization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamUtilizationQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamUtilization>>>
export type GetTeamUtilizationQueryError = ErrorType<unknown>


/**
 * @summary Team member utilization
 */

export function useGetTeamUtilization<TData = Awaited<ReturnType<typeof getTeamUtilization>>, TError = ErrorType<unknown>>(
 params?: GetTeamUtilizationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUtilization>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamUtilizationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRecentActivityUrl = (params?: GetRecentActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/recent-activity?${stringifiedParams}` : `/api/dashboard/recent-activity`
}

/**
 * @summary Recent time entries across the team
 */
export const getRecentActivity = async (params?: GetRecentActivityParams, options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry[]> => {

  return customFetch<TimeEntry[]>(getGetRecentActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecentActivityQueryKey = (params?: GetRecentActivityParams,) => {
    return [
    `/api/dashboard/recent-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRecentActivityQueryOptions = <TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<unknown>>(params?: GetRecentActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentActivity>>> = ({ signal }) => getRecentActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentActivity>>>
export type GetRecentActivityQueryError = ErrorType<unknown>


/**
 * @summary Recent time entries across the team
 */

export function useGetRecentActivity<TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<unknown>>(
 params?: GetRecentActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRecentActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientHoursTrendUrl = (params: GetClientHoursTrendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/client-hours-trend?${stringifiedParams}` : `/api/dashboard/client-hours-trend`
}

/**
 * @summary Billable/non-billable hours for a client bucketed by week or month
 */
export const getClientHoursTrend = async (params: GetClientHoursTrendParams, options?: Parameters<typeof customFetch>[1]): Promise<ClientHoursTrendPoint[]> => {

  return customFetch<ClientHoursTrendPoint[]>(getGetClientHoursTrendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClientHoursTrendQueryKey = (params?: GetClientHoursTrendParams,) => {
    return [
    `/api/dashboard/client-hours-trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientHoursTrendQueryOptions = <TData = Awaited<ReturnType<typeof getClientHoursTrend>>, TError = ErrorType<unknown>>(params: GetClientHoursTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHoursTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientHoursTrendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientHoursTrend>>> = ({ signal }) => getClientHoursTrend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientHoursTrend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientHoursTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getClientHoursTrend>>>
export type GetClientHoursTrendQueryError = ErrorType<unknown>


/**
 * @summary Billable/non-billable hours for a client bucketed by week or month
 */

export function useGetClientHoursTrend<TData = Awaited<ReturnType<typeof getClientHoursTrend>>, TError = ErrorType<unknown>>(
 params: GetClientHoursTrendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHoursTrend>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientHoursTrendQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPendingApprovalsUrl = () => {




  return `/api/dashboard/pending-approvals`
}

/**
 * @summary Time entries pending approval
 */
export const getPendingApprovals = async ( options?: Parameters<typeof customFetch>[1]): Promise<TimeEntry[]> => {

  return customFetch<TimeEntry[]>(getGetPendingApprovalsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPendingApprovalsQueryKey = () => {
    return [
    `/api/dashboard/pending-approvals`
    ] as const;
    }


export const getGetPendingApprovalsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingApprovalsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingApprovals>>> = ({ signal }) => getPendingApprovals({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPendingApprovalsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingApprovals>>>
export type GetPendingApprovalsQueryError = ErrorType<unknown>


/**
 * @summary Time entries pending approval
 */

export function useGetPendingApprovals<TData = Awaited<ReturnType<typeof getPendingApprovals>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingApprovals>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPendingApprovalsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPublicHolidaysUrl = () => {




  return `/api/public-holidays`
}

/**
 * @summary List all public holidays
 */
export const listPublicHolidays = async ( options?: Parameters<typeof customFetch>[1]): Promise<PublicHoliday[]> => {

  return customFetch<PublicHoliday[]>(getListPublicHolidaysUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPublicHolidaysQueryKey = () => {
    return [
    `/api/public-holidays`
    ] as const;
    }


export const getListPublicHolidaysQueryOptions = <TData = Awaited<ReturnType<typeof listPublicHolidays>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicHolidays>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPublicHolidaysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPublicHolidays>>> = ({ signal }) => listPublicHolidays({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPublicHolidays>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPublicHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof listPublicHolidays>>>
export type ListPublicHolidaysQueryError = ErrorType<unknown>


/**
 * @summary List all public holidays
 */

export function useListPublicHolidays<TData = Awaited<ReturnType<typeof listPublicHolidays>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPublicHolidays>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPublicHolidaysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePublicHolidayUrl = () => {




  return `/api/public-holidays`
}

/**
 * @summary Create a public holiday (MD only)
 */
export const createPublicHoliday = async (publicHolidayInput: PublicHolidayInput, options?: Parameters<typeof customFetch>[1]): Promise<PublicHoliday> => {

  return customFetch<PublicHoliday>(getCreatePublicHolidayUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicHolidayInput)
  }
);}





export const getCreatePublicHolidayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicHoliday>>, TError,{data: BodyType<PublicHolidayInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPublicHoliday>>, TError,{data: BodyType<PublicHolidayInput>}, TContext> => {

const mutationKey = ['createPublicHoliday'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicHoliday>>, {data: BodyType<PublicHolidayInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPublicHoliday(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicHolidayMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicHoliday>>>
    export type CreatePublicHolidayMutationBody = BodyType<PublicHolidayInput>
    export type CreatePublicHolidayMutationError = ErrorType<unknown>

    /**
 * @summary Create a public holiday (MD only)
 */
export const useCreatePublicHoliday = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicHoliday>>, TError,{data: BodyType<PublicHolidayInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPublicHoliday>>,
        TError,
        {data: BodyType<PublicHolidayInput>},
        TContext
      > => {
      return useMutation(getCreatePublicHolidayMutationOptions(options));
    }

export const getDeletePublicHolidayUrl = (id: number,) => {




  return `/api/public-holidays/${id}`
}

/**
 * @summary Delete a public holiday (MD only)
 */
export const deletePublicHoliday = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeletePublicHolidayUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePublicHolidayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicHoliday>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePublicHoliday>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePublicHoliday'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePublicHoliday>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePublicHoliday(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePublicHolidayMutationResult = NonNullable<Awaited<ReturnType<typeof deletePublicHoliday>>>

    export type DeletePublicHolidayMutationError = ErrorType<unknown>

    /**
 * @summary Delete a public holiday (MD only)
 */
export const useDeletePublicHoliday = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicHoliday>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePublicHoliday>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePublicHolidayMutationOptions(options));
    }

export const getListLeavesUrl = (params?: ListLeavesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leaves?${stringifiedParams}` : `/api/leaves`
}

/**
 * @summary List leave entries
 */
export const listLeaves = async (params?: ListLeavesParams, options?: Parameters<typeof customFetch>[1]): Promise<Leave[]> => {

  return customFetch<Leave[]>(getListLeavesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeavesQueryKey = (params?: ListLeavesParams,) => {
    return [
    `/api/leaves`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeavesQueryOptions = <TData = Awaited<ReturnType<typeof listLeaves>>, TError = ErrorType<unknown>>(params?: ListLeavesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaves>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeavesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaves>>> = ({ signal }) => listLeaves(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeaves>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeavesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaves>>>
export type ListLeavesQueryError = ErrorType<unknown>


/**
 * @summary List leave entries
 */

export function useListLeaves<TData = Awaited<ReturnType<typeof listLeaves>>, TError = ErrorType<unknown>>(
 params?: ListLeavesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeaves>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeavesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLogLeaveUrl = () => {




  return `/api/leaves`
}

/**
 * @summary Log a leave day
 */
export const logLeave = async (leaveInput: LeaveInput, options?: Parameters<typeof customFetch>[1]): Promise<Leave> => {

  return customFetch<Leave>(getLogLeaveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(leaveInput)
  }
);}





export const getLogLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logLeave>>, TError,{data: BodyType<LeaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logLeave>>, TError,{data: BodyType<LeaveInput>}, TContext> => {

const mutationKey = ['logLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logLeave>>, {data: BodyType<LeaveInput>}> = (props) => {
          const {data} = props ?? {};

          return  logLeave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof logLeave>>>
    export type LogLeaveMutationBody = BodyType<LeaveInput>
    export type LogLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Log a leave day
 */
export const useLogLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logLeave>>, TError,{data: BodyType<LeaveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logLeave>>,
        TError,
        {data: BodyType<LeaveInput>},
        TContext
      > => {
      return useMutation(getLogLeaveMutationOptions(options));
    }

export const getLogLeavesBulkUrl = () => {




  return `/api/leaves/bulk`
}

/**
 * @summary Log multiple leave days at once (skips duplicates)
 */
export const logLeavesBulk = async (leaveBulkInput: LeaveBulkInput, options?: Parameters<typeof customFetch>[1]): Promise<LeaveBulkResult> => {

  return customFetch<LeaveBulkResult>(getLogLeavesBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(leaveBulkInput)
  }
);}





export const getLogLeavesBulkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logLeavesBulk>>, TError,{data: BodyType<LeaveBulkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logLeavesBulk>>, TError,{data: BodyType<LeaveBulkInput>}, TContext> => {

const mutationKey = ['logLeavesBulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logLeavesBulk>>, {data: BodyType<LeaveBulkInput>}> = (props) => {
          const {data} = props ?? {};

          return  logLeavesBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogLeavesBulkMutationResult = NonNullable<Awaited<ReturnType<typeof logLeavesBulk>>>
    export type LogLeavesBulkMutationBody = BodyType<LeaveBulkInput>
    export type LogLeavesBulkMutationError = ErrorType<unknown>

    /**
 * @summary Log multiple leave days at once (skips duplicates)
 */
export const useLogLeavesBulk = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logLeavesBulk>>, TError,{data: BodyType<LeaveBulkInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logLeavesBulk>>,
        TError,
        {data: BodyType<LeaveBulkInput>},
        TContext
      > => {
      return useMutation(getLogLeavesBulkMutationOptions(options));
    }

export const getDeleteLeaveUrl = (id: number,) => {




  return `/api/leaves/${id}`
}

/**
 * @summary Delete a leave entry
 */
export const deleteLeave = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<MessageResponse> => {

  return customFetch<MessageResponse>(getDeleteLeaveUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLeaveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeave>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeave>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLeave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeave>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLeave(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeave>>>

    export type DeleteLeaveMutationError = ErrorType<unknown>

    /**
 * @summary Delete a leave entry
 */
export const useDeleteLeave = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeave>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeave>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteLeaveMutationOptions(options));
    }

export const getGetReportFilterOptionsUrl = () => {




  return `/api/reports/filter-options`
}

/**
 * @summary Scoped filter options for the current user
 */
export const getReportFilterOptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReportFilterOptions> => {

  return customFetch<ReportFilterOptions>(getGetReportFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportFilterOptionsQueryKey = () => {
    return [
    `/api/reports/filter-options`
    ] as const;
    }


export const getGetReportFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getReportFilterOptions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportFilterOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportFilterOptions>>> = ({ signal }) => getReportFilterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportFilterOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportFilterOptions>>>
export type GetReportFilterOptionsQueryError = ErrorType<unknown>


/**
 * @summary Scoped filter options for the current user
 */

export function useGetReportFilterOptions<TData = Awaited<ReturnType<typeof getReportFilterOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportFilterOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientReportUrl = (params?: GetClientReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/client-report?${stringifiedParams}` : `/api/reports/client-report`
}

/**
 * @summary Per-client utilization table (all windows) + optional monthly chart for one client
 */
export const getClientReport = async (params?: GetClientReportParams, options?: Parameters<typeof customFetch>[1]): Promise<ClientReport> => {

  return customFetch<ClientReport>(getGetClientReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClientReportQueryKey = (params?: GetClientReportParams,) => {
    return [
    `/api/reports/client-report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientReportQueryOptions = <TData = Awaited<ReturnType<typeof getClientReport>>, TError = ErrorType<unknown>>(params?: GetClientReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientReport>>> = ({ signal }) => getClientReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientReportQueryResult = NonNullable<Awaited<ReturnType<typeof getClientReport>>>
export type GetClientReportQueryError = ErrorType<unknown>


/**
 * @summary Per-client utilization table (all windows) + optional monthly chart for one client
 */

export function useGetClientReport<TData = Awaited<ReturnType<typeof getClientReport>>, TError = ErrorType<unknown>>(
 params?: GetClientReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamReportUrl = (params?: GetTeamReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/team-report?${stringifiedParams}` : `/api/reports/team-report`
}

/**
 * @summary Hours by Project and Task for selected users and clients
 */
export const getTeamReport = async (params?: GetTeamReportParams, options?: Parameters<typeof customFetch>[1]): Promise<TeamReportRow[]> => {

  return customFetch<TeamReportRow[]>(getGetTeamReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamReportQueryKey = (params?: GetTeamReportParams,) => {
    return [
    `/api/reports/team-report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamReportQueryOptions = <TData = Awaited<ReturnType<typeof getTeamReport>>, TError = ErrorType<unknown>>(params?: GetTeamReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamReport>>> = ({ signal }) => getTeamReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamReportQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamReport>>>
export type GetTeamReportQueryError = ErrorType<unknown>


/**
 * @summary Hours by Project and Task for selected users and clients
 */

export function useGetTeamReport<TData = Awaited<ReturnType<typeof getTeamReport>>, TError = ErrorType<unknown>>(
 params?: GetTeamReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCustomReportUrl = (params?: GetCustomReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/custom-report?${stringifiedParams}` : `/api/reports/custom-report`
}

/**
 * @summary Hours by client, project, person and task for a chosen slice
 */
export const getCustomReport = async (params?: GetCustomReportParams, options?: Parameters<typeof customFetch>[1]): Promise<CustomReport> => {

  return customFetch<CustomReport>(getGetCustomReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomReportQueryKey = (params?: GetCustomReportParams,) => {
    return [
    `/api/reports/custom-report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomReportQueryOptions = <TData = Awaited<ReturnType<typeof getCustomReport>>, TError = ErrorType<unknown>>(params?: GetCustomReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReport>>> = ({ signal }) => getCustomReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomReport>>>
export type GetCustomReportQueryError = ErrorType<unknown>


/**
 * @summary Hours by client, project, person and task for a chosen slice
 */

export function useGetCustomReport<TData = Awaited<ReturnType<typeof getCustomReport>>, TError = ErrorType<unknown>>(
 params?: GetCustomReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyReportUrl = (params?: GetMyReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/my-report?${stringifiedParams}` : `/api/reports/my-report`
}

/**
 * @summary Current user's hours by Project and Task with utilization summary
 */
export const getMyReport = async (params?: GetMyReportParams, options?: Parameters<typeof customFetch>[1]): Promise<MyReport> => {

  return customFetch<MyReport>(getGetMyReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyReportQueryKey = (params?: GetMyReportParams,) => {
    return [
    `/api/reports/my-report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyReportQueryOptions = <TData = Awaited<ReturnType<typeof getMyReport>>, TError = ErrorType<unknown>>(params?: GetMyReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReport>>> = ({ signal }) => getMyReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyReportQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReport>>>
export type GetMyReportQueryError = ErrorType<unknown>


/**
 * @summary Current user's hours by Project and Task with utilization summary
 */

export function useGetMyReport<TData = Awaited<ReturnType<typeof getMyReport>>, TError = ErrorType<unknown>>(
 params?: GetMyReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListProductsUrl = () => {




  return `/api/products`
}

/**
 * @summary List the product catalog
 */
export const listProducts = async ( options?: Parameters<typeof customFetch>[1]): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = () => {
    return [
    `/api/products`
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


/**
 * @summary List the product catalog
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProductUrl = () => {




  return `/api/products`
}

/**
 * @summary Define a product (Associate and above)
 */
export const createProduct = async (productInput: ProductInput, options?: Parameters<typeof customFetch>[1]): Promise<Product> => {

  return customFetch<Product>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productInput)
  }
);}





export const getCreateProductMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<ProductInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<ProductInput>
    export type CreateProductMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Define a product (Associate and above)
 */
export const useCreateProduct = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<ProductInput>},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options));
    }

export const getUpdateProductUrl = (productId: number,) => {




  return `/api/products/${productId}`
}

/**
 * @summary Rename or redescribe a product (Associate and above)
 */
export const updateProduct = async (productId: number,
    productUpdate: ProductUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Product> => {

  return customFetch<Product>(getUpdateProductUrl(productId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productUpdate)
  }
);}





export const getUpdateProductMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {productId: number;data: BodyType<ProductUpdate>}> = (props) => {
          const {productId,data} = props ?? {};

          return  updateProduct(productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<ProductUpdate>
    export type UpdateProductMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Rename or redescribe a product (Associate and above)
 */
export const useUpdateProduct = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{productId: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {productId: number;data: BodyType<ProductUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options));
    }

export const getDeleteProductUrl = (productId: number,) => {




  return `/api/products/${productId}`
}

/**
 * @summary Delete a product and its allocations (Associate and above)
 */
export const deleteProduct = async (productId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteProductUrl(productId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProductMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{productId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{productId: number}, TContext> => {

const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {productId: number}> = (props) => {
          const {productId} = props ?? {};

          return  deleteProduct(productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a product and its allocations (Associate and above)
 */
export const useDeleteProduct = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{productId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {productId: number},
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options));
    }

export const getListClientProductAssignmentsUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/product-assignments`
}

/**
 * @summary Who is producing what for a client
 */
export const listClientProductAssignments = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<ProductAssignment[]> => {

  return customFetch<ProductAssignment[]>(getListClientProductAssignmentsUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClientProductAssignmentsQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}/product-assignments`
    ] as const;
    }


export const getListClientProductAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listClientProductAssignments>>, TError = ErrorType<ErrorResponse>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientProductAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientProductAssignmentsQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientProductAssignments>>> = ({ signal }) => listClientProductAssignments(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientProductAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientProductAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listClientProductAssignments>>>
export type ListClientProductAssignmentsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Who is producing what for a client
 */

export function useListClientProductAssignments<TData = Awaited<ReturnType<typeof listClientProductAssignments>>, TError = ErrorType<ErrorResponse>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientProductAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientProductAssignmentsQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignProductUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/product-assignments`
}

/**
 * @summary Allocate a product to somebody (Associate and above)
 */
export const assignProduct = async (clientId: number,
    productAssignmentInput: ProductAssignmentInput, options?: Parameters<typeof customFetch>[1]): Promise<ProductAssignment> => {

  return customFetch<ProductAssignment>(getAssignProductUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productAssignmentInput)
  }
);}





export const getAssignProductMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProduct>>, TError,{clientId: number;data: BodyType<ProductAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignProduct>>, TError,{clientId: number;data: BodyType<ProductAssignmentInput>}, TContext> => {

const mutationKey = ['assignProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignProduct>>, {clientId: number;data: BodyType<ProductAssignmentInput>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  assignProduct(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignProductMutationResult = NonNullable<Awaited<ReturnType<typeof assignProduct>>>
    export type AssignProductMutationBody = BodyType<ProductAssignmentInput>
    export type AssignProductMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Allocate a product to somebody (Associate and above)
 */
export const useAssignProduct = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProduct>>, TError,{clientId: number;data: BodyType<ProductAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignProduct>>,
        TError,
        {clientId: number;data: BodyType<ProductAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignProductMutationOptions(options));
    }

export const getListMyProductAssignmentsUrl = () => {




  return `/api/my-product-assignments`
}

/**
 * @summary What the caller has been asked to produce
 */
export const listMyProductAssignments = async ( options?: Parameters<typeof customFetch>[1]): Promise<MyProductAssignment[]> => {

  return customFetch<MyProductAssignment[]>(getListMyProductAssignmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyProductAssignmentsQueryKey = () => {
    return [
    `/api/my-product-assignments`
    ] as const;
    }


export const getListMyProductAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listMyProductAssignments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyProductAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyProductAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyProductAssignments>>> = ({ signal }) => listMyProductAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyProductAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyProductAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyProductAssignments>>>
export type ListMyProductAssignmentsQueryError = ErrorType<unknown>


/**
 * @summary What the caller has been asked to produce
 */

export function useListMyProductAssignments<TData = Awaited<ReturnType<typeof listMyProductAssignments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyProductAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyProductAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteProductAssignmentUrl = (assignmentId: number,) => {




  return `/api/product-assignments/${assignmentId}`
}

/**
 * @summary Withdraw an allocation (Associate and above)
 */
export const deleteProductAssignment = async (assignmentId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteProductAssignmentUrl(assignmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProductAssignmentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAssignment>>, TError,{assignmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductAssignment>>, TError,{assignmentId: number}, TContext> => {

const mutationKey = ['deleteProductAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductAssignment>>, {assignmentId: number}> = (props) => {
          const {assignmentId} = props ?? {};

          return  deleteProductAssignment(assignmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductAssignment>>>

    export type DeleteProductAssignmentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Withdraw an allocation (Associate and above)
 */
export const useDeleteProductAssignment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAssignment>>, TError,{assignmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductAssignment>>,
        TError,
        {assignmentId: number},
        TContext
      > => {
      return useMutation(getDeleteProductAssignmentMutationOptions(options));
    }

export const getGetClientHourBlocksUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/hour-blocks`
}

/**
 * @summary Blocks bought by a client, and what is left
 */
export const getClientHourBlocks = async (clientId: number, options?: Parameters<typeof customFetch>[1]): Promise<HourBlockSummary> => {

  return customFetch<HourBlockSummary>(getGetClientHourBlocksUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClientHourBlocksQueryKey = (clientId: number,) => {
    return [
    `/api/clients/${clientId}/hour-blocks`
    ] as const;
    }


export const getGetClientHourBlocksQueryOptions = <TData = Awaited<ReturnType<typeof getClientHourBlocks>>, TError = ErrorType<ErrorResponse>>(clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHourBlocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientHourBlocksQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientHourBlocks>>> = ({ signal }) => getClientHourBlocks(clientId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientHourBlocks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientHourBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof getClientHourBlocks>>>
export type GetClientHourBlocksQueryError = ErrorType<ErrorResponse>


/**
 * @summary Blocks bought by a client, and what is left
 */

export function useGetClientHourBlocks<TData = Awaited<ReturnType<typeof getClientHourBlocks>>, TError = ErrorType<ErrorResponse>>(
 clientId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientHourBlocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientHourBlocksQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateHourBlockUrl = (clientId: number,) => {




  return `/api/clients/${clientId}/hour-blocks`
}

/**
 * @summary Record a purchase (Associate and above)
 */
export const createHourBlock = async (clientId: number,
    hourBlockInput: HourBlockInput, options?: Parameters<typeof customFetch>[1]): Promise<HourBlockRecord> => {

  return customFetch<HourBlockRecord>(getCreateHourBlockUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hourBlockInput)
  }
);}





export const getCreateHourBlockMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHourBlock>>, TError,{clientId: number;data: BodyType<HourBlockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHourBlock>>, TError,{clientId: number;data: BodyType<HourBlockInput>}, TContext> => {

const mutationKey = ['createHourBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHourBlock>>, {clientId: number;data: BodyType<HourBlockInput>}> = (props) => {
          const {clientId,data} = props ?? {};

          return  createHourBlock(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHourBlockMutationResult = NonNullable<Awaited<ReturnType<typeof createHourBlock>>>
    export type CreateHourBlockMutationBody = BodyType<HourBlockInput>
    export type CreateHourBlockMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Record a purchase (Associate and above)
 */
export const useCreateHourBlock = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHourBlock>>, TError,{clientId: number;data: BodyType<HourBlockInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHourBlock>>,
        TError,
        {clientId: number;data: BodyType<HourBlockInput>},
        TContext
      > => {
      return useMutation(getCreateHourBlockMutationOptions(options));
    }

export const getDeleteHourBlockUrl = (hourBlockId: number,) => {




  return `/api/hour-blocks/${hourBlockId}`
}

/**
 * @summary Remove a block recorded in error (Associate and above)
 */
export const deleteHourBlock = async (hourBlockId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteHourBlockUrl(hourBlockId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteHourBlockMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHourBlock>>, TError,{hourBlockId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHourBlock>>, TError,{hourBlockId: number}, TContext> => {

const mutationKey = ['deleteHourBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHourBlock>>, {hourBlockId: number}> = (props) => {
          const {hourBlockId} = props ?? {};

          return  deleteHourBlock(hourBlockId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHourBlockMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHourBlock>>>

    export type DeleteHourBlockMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Remove a block recorded in error (Associate and above)
 */
export const useDeleteHourBlock = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHourBlock>>, TError,{hourBlockId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHourBlock>>,
        TError,
        {hourBlockId: number},
        TContext
      > => {
      return useMutation(getDeleteHourBlockMutationOptions(options));
    }

export const getListProjectTaskAssignmentsUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/task-assignments`
}

/**
 * @summary Who is doing what on a project
 */
export const listProjectTaskAssignments = async (projectId: number, options?: Parameters<typeof customFetch>[1]): Promise<ProjectTaskAssignment[]> => {

  return customFetch<ProjectTaskAssignment[]>(getListProjectTaskAssignmentsUrl(projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjectTaskAssignmentsQueryKey = (projectId: number,) => {
    return [
    `/api/projects/${projectId}/task-assignments`
    ] as const;
    }


export const getListProjectTaskAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectTaskAssignments>>, TError = ErrorType<ErrorResponse>>(projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectTaskAssignmentsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectTaskAssignments>>> = ({ signal }) => listProjectTaskAssignments(projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectTaskAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectTaskAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectTaskAssignments>>>
export type ListProjectTaskAssignmentsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Who is doing what on a project
 */

export function useListProjectTaskAssignments<TData = Awaited<ReturnType<typeof listProjectTaskAssignments>>, TError = ErrorType<ErrorResponse>>(
 projectId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProjectTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProjectTaskAssignmentsQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAssignProjectTaskUrl = (projectId: number,) => {




  return `/api/projects/${projectId}/task-assignments`
}

/**
 * @summary Assign a task to somebody on the project (Associate and above)
 */
export const assignProjectTask = async (projectId: number,
    projectTaskAssignmentInput: ProjectTaskAssignmentInput, options?: Parameters<typeof customFetch>[1]): Promise<ProjectTaskAssignmentRecord> => {

  return customFetch<ProjectTaskAssignmentRecord>(getAssignProjectTaskUrl(projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(projectTaskAssignmentInput)
  }
);}





export const getAssignProjectTaskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProjectTask>>, TError,{projectId: number;data: BodyType<ProjectTaskAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignProjectTask>>, TError,{projectId: number;data: BodyType<ProjectTaskAssignmentInput>}, TContext> => {

const mutationKey = ['assignProjectTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignProjectTask>>, {projectId: number;data: BodyType<ProjectTaskAssignmentInput>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  assignProjectTask(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignProjectTaskMutationResult = NonNullable<Awaited<ReturnType<typeof assignProjectTask>>>
    export type AssignProjectTaskMutationBody = BodyType<ProjectTaskAssignmentInput>
    export type AssignProjectTaskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Assign a task to somebody on the project (Associate and above)
 */
export const useAssignProjectTask = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProjectTask>>, TError,{projectId: number;data: BodyType<ProjectTaskAssignmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignProjectTask>>,
        TError,
        {projectId: number;data: BodyType<ProjectTaskAssignmentInput>},
        TContext
      > => {
      return useMutation(getAssignProjectTaskMutationOptions(options));
    }

export const getDeleteProjectTaskAssignmentUrl = (assignmentId: number,) => {




  return `/api/task-assignments/${assignmentId}`
}

/**
 * @summary Withdraw an assignment (Associate and above)
 */
export const deleteProjectTaskAssignment = async (assignmentId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteProjectTaskAssignmentUrl(assignmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProjectTaskAssignmentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectTaskAssignment>>, TError,{assignmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectTaskAssignment>>, TError,{assignmentId: number}, TContext> => {

const mutationKey = ['deleteProjectTaskAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectTaskAssignment>>, {assignmentId: number}> = (props) => {
          const {assignmentId} = props ?? {};

          return  deleteProjectTaskAssignment(assignmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectTaskAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectTaskAssignment>>>

    export type DeleteProjectTaskAssignmentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Withdraw an assignment (Associate and above)
 */
export const useDeleteProjectTaskAssignment = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectTaskAssignment>>, TError,{assignmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectTaskAssignment>>,
        TError,
        {assignmentId: number},
        TContext
      > => {
      return useMutation(getDeleteProjectTaskAssignmentMutationOptions(options));
    }

export const getListMyTaskAssignmentsUrl = () => {




  return `/api/my-task-assignments`
}

/**
 * @summary What the caller has been asked to do
 */
export const listMyTaskAssignments = async ( options?: Parameters<typeof customFetch>[1]): Promise<MyTaskAssignment[]> => {

  return customFetch<MyTaskAssignment[]>(getListMyTaskAssignmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyTaskAssignmentsQueryKey = () => {
    return [
    `/api/my-task-assignments`
    ] as const;
    }


export const getListMyTaskAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listMyTaskAssignments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyTaskAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTaskAssignments>>> = ({ signal }) => listMyTaskAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyTaskAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyTaskAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyTaskAssignments>>>
export type ListMyTaskAssignmentsQueryError = ErrorType<unknown>


/**
 * @summary What the caller has been asked to do
 */

export function useListMyTaskAssignments<TData = Awaited<ReturnType<typeof listMyTaskAssignments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyTaskAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







